module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('van-button', {
    attrs: {
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.orderQuery
    }
  }, [_vm._v("返回")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "width": "100%",
      "height": "360",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "http://new.ynyzxjy.cn/newBaoPublic/static/mp4/learn_apply.mp4",
      "type": "video/mp4",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee63bb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/learn.vue
// module id = 467
// module chunks = 1